<template>
  <div class="p-3 border">
    <div v-for="option in options" :key="option[optionValue]" class="flex items-center mb-2">
      <Checkbox v-model="selectedOptions" :value="option[optionValue]" />
      <label class="ml-2"><i :class="['mr-2', 'text-' + option.iconColor, option.icon]"></i>{{ option[optionLabel] }}</label>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  options: {
    type: Array,
    required: true
  },
  modelValue: {
    type: Array,
    required: true
  },
  optionValue: {
    type: String,
    required: true
  },
  optionLabel: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);
const selectedOptions = ref([...props.modelValue]);

watch(selectedOptions, (newValue) => {
  if (newValue !== props.modelValue) {
    emit('update:modelValue', newValue);
  }
});

watch(() => props.modelValue, (newValue) => {
  if (newValue !== selectedOptions.value) {
    selectedOptions.value = [...newValue];
  }
});

</script>

<style>
/* Tailwind CSS classes are used directly in the template */
</style>
